module.exports = __webpack_public_path__ + "img/normal-big.7dc87b71.svg";